import type { FaireProductEntity } from "../../entity_types/product";

export const p_gh9ectwz59: FaireProductEntity = {
  token: "p_gh9ectwz59",
  type: "product",
  name: "Hooded Halloween Sweater with Jaco O Embroidery",
  brandToken: "b_8emw35kxrq",
  brandName: "Mello.",
  imageUrl:
    "https://cdn.faire.com/fastly/be088bec105e4810b232f2aadbbcb8398d66291c50fb0237c9166740dd0e37cd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9b71c56931899882bade5d468a193cbbd8bf786486ce00180f2311af2dfe2f1f.jpeg",
    "https://cdn.faire.com/fastly/c61c05d809c896462a9c19136ae69de496efa0ece288051d75cd1e3acffd5f54.jpeg",
    "https://cdn.faire.com/fastly/9448bed9e258f5692f62b39d9b482b29d07b71e5021df96eb172cd98ea70a324.jpeg",
    "https://cdn.faire.com/fastly/f2c85e005c0b5ec4dd568a5143d457e329868ff153604744153bbb8c3dddec23.jpeg",
    "https://cdn.faire.com/fastly/a2101bccdd88b5335936aa9e4d8df43131db49e84f9a6cc93b2f8806766314f1.jpeg",
    "https://cdn.faire.com/fastly/9b1d8091d22eb502c3f88b2f98c871219512ae74dcb9c002c7147017f04e47db.jpeg",
    "https://cdn.faire.com/fastly/d2d3d7613c9dfc7050469756d650f209e139ab9965583c2b17fd314f8b6868b2.jpeg",
    "https://cdn.faire.com/fastly/55da991af271dcda59d6c756d2cb0dd7ec51dfdad7213932b3e1a7d0b41873f5.jpeg",
    "https://cdn.faire.com/fastly/de6f7f6718f5d1beecb576f70ce6f12ddb3c01b198aaea0f4cf74fe5222e7a0d.jpeg",
  ],
  priceDollars: 161.4,
  description:
    "Hooded Halloween Sweater with Jaco O Embroidery\n\nSize: Small\n\nActual product color may vary from the images shown. Every monitor or mobile display has a different capability to display colors, and every individual may see these colors differently.",
  tags: [],
  msrpDollars: 322.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:39.949Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
